import { render, staticRenderFns } from "./AccountCreated.vue?vue&type=template&id=4662b35c&scoped=true&"
import script from "./AccountCreated.vue?vue&type=script&lang=js&"
export * from "./AccountCreated.vue?vue&type=script&lang=js&"
import style0 from "./AccountCreated.vue?vue&type=style&index=0&id=4662b35c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4662b35c",
  null
  
)


    import installComponents from "!/Users/dhulsman/Projects/rentmagic.website.vue.hva/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BAlert, BCol, BRow, BContainer} from 'bootstrap-vue'
    installComponents(component, {BAlert, BCol, BRow, BContainer})
    

export default component.exports